import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as Actions from 'actions';

const arrayToObject = (arr) => {
  let obj = {};
  arr.forEach(e => {obj = {...obj, [e.key] : e.url}});

  return obj;
}

class MarkerTypesSelector extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hovered_item : null
    }

    this.renderMarkerRow = this.renderMarkerRow.bind(this)
  }

  renderMarkerRow(idx) {
    let { baseUrl, imagesPath } = this.props.connection;
    let { marker_types, current_marker_key } = this.props;
    let slice_value = 4 * idx;

    if(Array.isArray(marker_types)) {
      marker_types = arrayToObject(marker_types);
    }
    return (
      Object.keys(marker_types)
      .slice(slice_value, (slice_value + 4))
      .map(key => {
        const marker = marker_types[key];

        return (
          <div className={`col-md-3 col-xs-3 mb-md map-marker-container`} key={key}>
            <img
              className={this.state.hovered_item == key ? 'animated pulse' : ''}
              src={`${baseUrl}${imagesPath}${marker}`}
              onMouseEnter={() => setTimeout(this.setState({hovered_item : key}), 20)}
              onMouseLeave={() => this.setState({hovered_item : null})}
              onClick={() => this.props.handleSelectMarker(key, current_marker_key)}
            />
        </div>
        )
      })
    )
  }

  render() {
    const { baseUrl, imagesPath } = this.props.connection;
    const { marker_types } = this.props;

    if(marker_types) {
      // Initialize array to render rows
      let marker_rows_arr = [];
      for(let i = 0; i < Object.keys(marker_types).length / 4; i++) {
        marker_rows_arr.push(i)
      }

      return (
        <div className='marker-types-selector-container'>
          {marker_rows_arr.map((row, idx) => {
            return (
              <div className='row' key={idx}>
                {this.renderMarkerRow(row)}
              </div>
            )
          })}
        </div>
      )
    }

    return <div></div>
  }
}

let mapStateToProps = ({connection}) => ({connection})

export default connect(mapStateToProps, Actions)(MarkerTypesSelector)



// WEBPACK FOOTER //
// ./src/browser/components/clients/canvassing/marker-types-selector.js